export enum Event {
  BANNER_VIEW = 'Banner View',
  CLOSE_BANNER_CLICK = 'Close Banner Click',
  ACCESS_BANNER_CLICK = 'Access Banner Click',
  PROMOTION_VIEW = 'Promotion View',
  DUPLICATED_PROMOTION = 'Duplicated Promotion',
  PROMOTION_DISCARD_CLICK = 'Promotion Discard Click',
  NAVIGATED_TO_NEW_PROMOTION_FORM = 'Navigated to New Promotion Form',
  PROMOTION_SAVED = 'Promotion Saved',
  ERROR_SAVING_PROMOTION = 'Error Saving Promotion',
  TRIED_TO_SAVE_INVALID_FORM = 'Tried to Save Invalid Form',
  PROMOTION_UNARCHIVED = 'Promotion Unarchived',
  NAVIGATED_TO_ARCHIVED_PROMOTION = 'Navigated to Archived Promotion',
  ARCHIVED_PROMOTIONS_LISTED = 'Archived Promotions Listed',
  ARCHIVED_SEARCH_PERFORMED = 'Archived Search Performed',
  ARCHIVED_PAGE_CHANGED = 'Archived Page Changed',
  PROMOTION_REVIEW_STARTED = 'Promotion Review Started',
  PROMOTION_REVIEW_ABANDONED = 'Promotion Review Abandoned',
  PROMOTION_REVIEW_FINISHED = 'Promotion Review Finished',
  NAVIGATED_TO_PROMOTION = 'Navigated to Promotion',
  PROMOTIONS_EXPORTED = 'Promotions Exported',
  USAGE_INFO_VIEWED = 'Usage Info Viewed',
  PROMOTION_STATUS_CHANGED = 'Promotion Status Changed',
  UNDO_PROMOTION_STATUS_CHANGE = 'Undo Promotion Status Change',
  CREATE_COUPON_BY_UTM_CLICK = 'Create Coupon by UTM Click',
  COUPON_DRAWER_VIEW = 'Coupon Drawer View',
  COUPON_SAVE_CLICK = 'Coupon Save Click',
  COUPON_CREATE_SUCCESS = 'Coupon Create Success',
  COUPON_CREATE_ERROR = 'Coupon Create Error',
  CARD_ACTION_EDIT_CLICK = 'Card Action Edit Click',
  CARD_EDIT_CLICK = 'Card Edit Click',
  DUPLICATE_MODAL_VIEW = 'Duplicate Modal View',
  DUPLICATE_MODAL_CANCEL_CLICK = 'Duplicate Modal Cancel Click',
  DUPLICATE_MODAL_CONFIRM_CLICK = 'Duplicate Modal Confirm Click',
  DUPLICATE_MODAL_CHANGE_CLICK = 'Duplicate Modal Change Click',
  PROMOTION_DUPLICATED_SAVED = 'Promotion Duplicated Saved',
  PROMOTION_FROM_TEMPLATE_SAVED = 'Promotion From Template Saved',
  INCOMPATIBLE_MODAL_VIEW = 'Incompatible Modal View',
  INCOMPATIBLE_MODAL_CANCEL_CLICK = 'Incompatible Modal Cancel Click',
  INCOMPATIBLE_MODAL_CONFIRM_CLICK = 'Incompatible Modal Confirm Click',
  SELLER_SELECTION_CHANGED = 'Seller Selection Changed',
  OPT_IN_LEARN_MORE_CLICK = 'Opt-in Learn More Click',
  BUDGET_SAVE_SUCCESS = 'Budget Save Success',
  BUDGET_DELETE_SUCCESS = 'Budget Delete Success',
  BUDGET_PERMISSION_ERROR = 'Budget Permission Error',
  BUDGET_DRAWER_VIEW = 'Budget Drawer View',
  BUDGET_DRAWER_CANCEL_CLICK = 'Budget Drawer Cancel Click',
  BUDGET_DRAWER_CONFIRM_CLICK = 'Budget Drawer Confirm Click',
  BUDGET_NOTIFICATION_SETTINGS_CLICK = 'Budget Notification Settings Click',
  BUDGET_MODAL_DELETE_VIEW = 'Budget Modal Delete View',
  BUDGET_MODAL_DELETE_CANCEL_CLICK = 'Budget Modal Delete Cancel Click',
  BUDGET_MODAL_DELETE_CONFIRM_CLICK = 'Budget Modal Delete Confirm Click',
  BUDGET_VIEW = 'Budget View',
  SCOPE_PERCENTAGE_VIEW = 'Scope Percentage View',
  SCOPE_ALERT_VIEW = 'Scope Alert View',
  PRODUCT_PERCENTAGE_VIEW = 'Product Percentage View',
  PRODUCT_PERCENTAGE_ALERT_VIEW = 'Product Percentage Alert View',
  CREATE_PROMOTION_DRAWER_VIEW = 'Create Promotion Drawer View',
  CREATE_PROMOTION_DRAWER_CLOSE_CLICK = 'Create Promotion Drawer Close Click',
  CREATE_PROMOTION_DRAWER_TAB_CLICK = 'Create Promotion Drawer Tab Click',
  CREATE_TEMPLATE_BUTTON_CLICK = 'Create Template Button Click',
  TEMPLATE_SAVE_CLICK = 'Template Save Click',
  CREATE_TEMPLATE_MODAL_CLOSE_CLICK = 'Create Template Modal Close Click',
  CREATE_TEMPLATE_MODAL_VIEW = 'Create Template Modal View',
  TEMPLATE_MENU_EDIT_CLICK = 'Template Menu Edit Click',
  TEMPLATE_MENU_REMOVE_CLICK = 'Template Menu Remove Click',
  NAVIGATED_TO_TEMPLATE = 'Navigated to Template',
  TEMPLATE_DELETE_CONFIRM_CLICK = 'Template Delete Confirm Click',
  LEARN_MORE_CLICK = 'Learn More Click',
  FORMULA_CARD_OPEN = 'Open Formula Card',
  DURATION_TRACE = 'Duration Trace'
}

export enum WatchedIncompatibleField {
  BENEFIT = 'benefit',
}
